<template>
  <div class="map-card" slot="image" style="height: 250px;">
    <l-map ref="parcMap" :zoom="mapZoom" :center="mapCenter">
      <l-tile-layer :url="baseLayer.url" :attribution="baseLayer.attribution" />
      <l-marker
        v-for="eolienne in eoliennesGeomList"
        :lat-lng="eolienne.latLng"
        :key="eolienne.id"
        @mouseover="onMarkerHover(eolienne.id)"
        @mouseout="onMarkerOut"
      >
        <l-tooltip :options="{ permanent: 'true', opacity: 0 }">
          {{ eolienne.id }}
        </l-tooltip>
      </l-marker>
      <l-marker
        v-for="poste in postesLivraisonGeomList"
        :lat-lng="poste.latLong"
        :key="poste.id"
        @mouseover="onMarkerHover(poste.id)"
        @mouseout="onMarkerOut"
      >
        <l-icon
          :icon-size="[22, 36]"
          :icon-anchor="[12, 41]"
          :icon-url="iconUrl"
        >
        </l-icon>
        <l-tooltip :options="{ permanent: 'true', opacity: 0 }">
          {{ poste.id }}
        </l-tooltip>
      </l-marker>
      <l-polygon v-if="isParcGeom" :lat-lngs="parcGeom" :color="color"></l-polygon>
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LTooltip, LIcon, LPolygon } from "@vue-leaflet/vue-leaflet"
import { mapGetters } from "vuex"
import {mapService} from "@/service/map.service";

export default {
  components: { LMap, LTileLayer, LMarker, LTooltip, LIcon, LPolygon },
  computed: {
    ...mapGetters([
      'eoliennesGeomList',
      'postesLivraisonGeomList',
      'baseLayer',
      'projections',
      'epsg',
      'parc'
    ]),
    mapZoom() {
      if (this.isParcGeom) {
        return 13;
      }
      return this.projections[this.epsg].zoom;
    },
    mapCenter() {
      return this.isParcGeom
        ? mapService.getMultipolygonCenter(this.parcGeom)
        : this.projections[this.epsg].wgs84Center;
    },
    isParcGeom() {
      return !!this.parc.geomWgs84;
    },
    parcGeom() {
      if (this.isParcGeom) {
        return this.parc.geomWgs84.coordinates[0][0].map(point => {
          return [point[1], point[0]];
        });
      }
    },
  },
  methods: {
    onMarkerHover(elementId) {
      this.$store.dispatch("saveSelectedMapElement", elementId);
    },
    onMarkerOut() {
      this.$store.dispatch("clearSelectedMapElement");
    },
  },
  data() {
    return {
      color: "#FFFFCC",
      iconUrl: require("../../assets/img/marker-icon-2x-green.png")
    };
  },
}
</script>
